import Link from "next/link";
import styles from "./Breadcrumb.module.css";

export default function Breadcrumb({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" className={styles.breadcrumb}>
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className={styles.item}>
              {isLast || !item.url ? (
                <span className={styles.current}>{item.label}</span>
              ) : (
                <>
                  <Link href={item.url} className={styles.link}>
                    {item.label}
                  </Link>
                  <span className={styles.separator}> &gt; </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
